import { render } from "./EditprofileView.vue?vue&type=template&id=a3e060e0"
import script from "./EditprofileView.vue?vue&type=script&lang=js"
export * from "./EditprofileView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__